export enum LancarPedidoRapidoTipo{

	PEDIDO_PORTARIA = <any>'0',
	PEDIDO_ENTREGADOR = <any>'1'

}
